import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { PageContentComponent } from './page-content.component';
import { PageContentEffects } from './page-content.effects';
import { pageContentReducer } from './page-content.reducer';
import {
  STATE_PAGE_CONTENT,
  getInitialPageContentState,
} from './page-content.state';
import { PageResourceService } from './page-resource.service';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([PageContentEffects]),
    StoreModule.forFeature(STATE_PAGE_CONTENT, pageContentReducer, {
      initialState: getInitialPageContentState,
    }),
    TarlV3JsonapiModule,
  ],
  declarations: [PageContentComponent],
  exports: [PageContentComponent],
  providers: [PageResourceService],
})
export class PageContentModule {}
